import Component from '@averyano/core/src/classes/Component';
import each from 'lodash/each';

export default class WhoFeedbackSection extends Component {
	constructor() {
		super({
			element: '.who',
			elements: {
				grid: '.who__feedback-grid',
				cards: '.who__feedback-item',
				arrowPrev: '.who__feedback-arrow--prev',
				arrowNext: '.who__feedback-arrow--next',
			},
		});
	}

	create() {
		super.createComponent();
		this.updateArrows();
	}

	currentIndex() {
		const { grid, cards } = this.elements;
		const viewCenter = grid.scrollLeft + grid.clientWidth / 2;
		let current = 0;
		let min = Infinity;
		each(cards, (card, i) => {
			const cardCenter = card.offsetLeft + card.offsetWidth / 2;
			const d = Math.abs(cardCenter - viewCenter);
			if (d < min) {
				min = d;
				current = i;
			}
		});
		return current;
	}

	scrollTo(index) {
		const { grid, cards } = this.elements;
		if (!grid || !cards || !cards.length) return;
		const clamped = Math.max(0, Math.min(index, cards.length - 1));
		const card = cards[clamped];
		const left = card.offsetLeft + card.offsetWidth / 2 - grid.clientWidth / 2;
		grid.scrollTo({ left, behavior: 'smooth' });
	}

	updateArrows() {
		const { cards, arrowPrev, arrowNext } = this.elements;
		if (!cards || !cards.length) return;
		const i = this.currentIndex();
		arrowPrev?.classList.toggle('is-hidden', i <= 0);
		arrowNext?.classList.toggle('is-hidden', i >= cards.length - 1);
	}

	addEventListeners() {
		this.onPrev = () => this.scrollTo(this.currentIndex() - 1);
		this.onNext = () => this.scrollTo(this.currentIndex() + 1);
		this.onGridScroll = () => this.updateArrows();

		this.elements.arrowPrev?.addEventListener('click', this.onPrev);
		this.elements.arrowNext?.addEventListener('click', this.onNext);
		this.elements.grid?.addEventListener('scroll', this.onGridScroll, {
			passive: true,
		});
	}

	removeEventListeners() {
		this.elements?.arrowPrev?.removeEventListener('click', this.onPrev);
		this.elements?.arrowNext?.removeEventListener('click', this.onNext);
		this.elements?.grid?.removeEventListener('scroll', this.onGridScroll);
	}

	onResize() {
		this.updateArrows();
	}

	destroy() {
		this.removeEventListeners();
		super.destroy();
	}
}
